exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "companies-detail{display:flex;height:100%}companies-detail .hide-dpicker-header table thead{display:none}companies-detail .hide-dpicker-header table tbody .current{background-color:transparent}companies-detail .details-content{display:flex;width:100%;height:100%;flex-direction:column}companies-detail .page-header{margin-top:20px;border:none;padding-bottom:0;flex:0 0 32px}companies-detail .scrollable{flex:1 1 100%;overflow:auto}companies-detail ul.nav-justified{text-align:center;padding:0;background-color:#f9f9f9;list-style:none}companies-detail ul.nav-justified li{padding:20px 15px;border:1px solid #fff}companies-detail ul.nav-justified li.active,companies-detail ul.nav-justified li:hover{background-color:#fa5a00;transition:all .3s;cursor:pointer;color:#fff;font-weight:700}companies-detail .users-toolbar{display:flex;width:50%;max-width:500px}companies-detail .users-toolbar>div{flex:1 1 100%}companies-detail .users-toolbar .arch-checkbox{padding:5px;flex:0 0 100px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/admin/companies/companies-detail/companies-detail.styl
 ** module id = 384
 ** module chunks = 0
 **/